module.exports = __webpack_public_path__ + "img/1549613880.17e2525e.jpg";